const extractSubdomain = (host: string): string | undefined => {
    // Remove port if present (e.g., localhost:3000)
    const hostWithoutPort = host.split(':')[0]
    const parts = hostWithoutPort.split('.')

    // Extract first part as subdomain
    // Examples: "tintash.abovedata.com" -> "tintash", "localhost" -> "localhost"
    if (parts.length >= 1) {
        return parts[0]
    }

    return undefined
}

export const getSubdomainFromHost = (): string | undefined => {
    if (typeof window === 'undefined') {
        return undefined
    }
    const host = window.location.hostname
    const subdomain = extractSubdomain(host)
    return subdomain
}
